import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";

const PostgraduateEducation: FC = () => {
    return (
      <Box mt={1}>
        <Header>
            <Box display='flex'>
                <TextField
                    label="Послевузовское профессиональное"
                    variant="outlined"
                    size="small"
                    sx={{ width: "800px" }}
                />
            </Box>
            <Box display='flex'>
                <Typography sx={{mb: 2, ml: 1}}> (аспирантура, адъюнктура, докторантура ) </Typography>
            </Box>
            <Box display='flex'>
                <TextField
                    label="Наименование образовательного, научного учреждения"
                    variant="outlined"
                    size="small"
                    sx={{ mb: 2, width: "800px" }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="Документ об образовании, номер, дата выдачи"
                    variant="outlined"
                    size="small"
                    sx={{ mb: 2, width: "800px" }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="Дата окончания"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 2 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="Направление или специальность по документу"
                    variant="outlined"
                    size="small"
                    sx={{ width: "800px" }}
                />
            </Box>
        </Header>
        <Body>

        </Body>
      </Box>
    );
};
export default PostgraduateEducation;
